import { render, staticRenderFns } from "./RejectDialog.vue?vue&type=template&id=2b0bc662&scoped=true"
import script from "./RejectDialog.vue?vue&type=script&lang=js"
export * from "./RejectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bc662",
  null
  
)

export default component.exports